import { normalizeForLlm, } from "../../services/chatImageNormalizationService";
const IMAGE_UPLOAD_EXTENSIONS = new Set([
    ".png",
    ".jpg",
    ".jpeg",
    ".gif",
    ".webp",
    ".bmp",
    ".tiff",
    ".tif",
    ".svg",
    ".heic",
    ".heif",
    ".avif",
]);
const formatImageNormalizationError = (file, error) => {
    const name = file.name || "Unnamed image";
    if (error.code === "unsupported_format") {
        return `${name}: unsupported format (${error.originalMimeType}).`;
    }
    if (error.code === "decode_failed") {
        return `${name}: could not decode image (${error.originalMimeType}).`;
    }
    if (error.code === "not_image") {
        return `${name}: not recognized as an image.`;
    }
    return `${name}: ${error.message}`;
};
export const isImageFile = (file) => {
    if (file.type && file.type.toLowerCase().startsWith("image/")) {
        return true;
    }
    const lowerName = file.name.toLowerCase();
    const dotIndex = lowerName.lastIndexOf(".");
    if (dotIndex < 0)
        return false;
    return IMAGE_UPLOAD_EXTENSIONS.has(lowerName.slice(dotIndex));
};
export async function createImageAttachmentsFromFiles(files, idPrefix) {
    const imageFiles = files.filter(isImageFile);
    if (imageFiles.length === 0) {
        return { attachments: [], errors: [], createdContextIds: [] };
    }
    const attachments = [];
    const errors = [];
    const createdContextIds = [];
    for (const file of imageFiles) {
        const normalized = await normalizeForLlm(file);
        if (!normalized.ok) {
            errors.push(formatImageNormalizationError(file, normalized));
            continue;
        }
        if (!window.__storeChatInputImage) {
            errors.push(`${file.name || "Unnamed image"}: chat image storage is unavailable.`);
            continue;
        }
        const stored = await window.__storeChatInputImage(normalized.base64, normalized.mimeType, file.name);
        if (!stored?.contextId) {
            errors.push(`${file.name || "Unnamed image"}: failed to store image context.`);
            continue;
        }
        const imageId = `${idPrefix}_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
        attachments.push({
            id: imageId,
            contextId: stored.contextId,
            name: file.name || "Image",
            mimeType: normalized.mimeType,
            originalMimeType: normalized.originalMimeType,
            converted: normalized.converted,
            previewUrl: normalized.previewDataUrl,
            sizeBytes: file.size,
        });
        createdContextIds.push(stored.contextId);
    }
    return { attachments, errors, createdContextIds };
}
export async function deleteContextImageById(contextId) {
    if (!contextId || !window.__deleteContextImage) {
        return;
    }
    try {
        await window.__deleteContextImage(contextId);
    }
    catch {
        // Best effort cleanup for unsent image context.
    }
}
export async function deleteContextImagesBestEffort(contextIds) {
    for (const contextId of contextIds) {
        await deleteContextImageById(contextId);
    }
}
